import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/tailwind.css";
import "./styles/index.css";

// Add smooth scroll behavior to html element
if (typeof document !== 'undefined') {
  document.documentElement?.classList?.add('smooth-scroll');
}

// Register service worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker?.register('/sw.js')?.then((registration) => {
        console.log('[PWA] Service Worker registered:', registration?.scope);
      })?.catch((error) => {
        console.error('[PWA] Service Worker registration failed:', error);
      });
  });
}

const container = document.getElementById("root");
const root = createRoot(container);

root.render(<App />);
